import { FC, memo } from 'react';
import loadable from '@loadable/component';

import usePage from '@Queries/usePage';
import { PageWikiArticleData } from '@Pages/PageWikiArticle';

const TemplateService = loadable(() => import('@Templates/TemplateService'));
const PageWikiArticle = loadable(() => import('@Pages/PageWikiArticle'));
const Route404 = loadable(() => import('@Routes/Route404'));

const RouteWikiArticle: FC = () => {
  const page = usePage<PageWikiArticleData>();

  if (!page.isSuccess) return null;
  if (!page.data.content) return <Route404 />;

  return (
    <TemplateService breadcrumbs={page.data.breadcrumbs}>
      <PageWikiArticle page={page.data} />
    </TemplateService>
  );
};

export default memo(RouteWikiArticle);
